var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWIllness3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0 0 77 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 55,
    rx: 27,
    fill: "#FDF2D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0463 13.5776H26.2196C25.2688 13.5776 24.498 14.3484 24.498 15.2991V39.701C24.498 40.6518 25.2688 41.4225 26.2196 41.4225H30.0463C30.997 41.4225 31.7678 40.6518 31.7678 39.701V15.2991C31.7678 14.3484 30.997 13.5776 30.0463 13.5776Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3158 13.5776H33.4891C32.5383 13.5776 31.7676 14.3484 31.7676 15.2991V39.701C31.7676 40.6518 32.5383 41.4225 33.4891 41.4225H37.3158C38.2666 41.4225 39.0373 40.6518 39.0373 39.701V15.2991C39.0373 14.3484 38.2666 13.5776 37.3158 13.5776Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3965 17.2798H30.078",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5625 17.2798H37.244",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3965 35.3091H30.078",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3965 38.0522H30.078",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5625 35.3091H37.244",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5625 38.0522H37.244",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5524 41.438L51.2184 40.432C52.1414 40.178 52.691 39.2187 52.4369 38.2853L46.1109 14.7909C45.862 13.8576 44.9079 13.3079 43.9798 13.562L40.3138 14.568C39.3908 14.822 38.8412 15.7813 39.0953 16.7147L45.4213 40.2091C45.6702 41.1424 46.6243 41.6921 47.5524 41.438Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3359 18.1252L44.893 17.1504",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0176 35.5266L49.5747 34.5518",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7324 38.1711L50.2843 37.1963",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWIllness3);
export default __webpack_public_path__ + "static/media/w-illness3.1fb4a7f564cc31c849ef5c2a6c38e43f.svg";
export { ForwardRef as ReactComponent };